module.exports = __webpack_public_path__ + "2202211bf54c0497bc616df66c009883.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/books.png
// module id = 3024
// module chunks = 0